import api from "../api/axios";

const sendMailForCampaign = async (
  file,
  subject,
  content,
  mail,
  password,
  companyName
) => {
  const formData = new FormData();
  formData.append("email_data", file);
  formData.append("subject", subject);
  formData.append("content", content);
  formData.append("senderEmail", mail);
  formData.append("password", password);
  formData.append("companyName", companyName);

  const response = await api.post(`send-mail-for-campaign`, formData);
  return response.data;
};

const getTemplates = async () => {
  const response = await api.get(`email-templates`);
  return response.data;
};

const saveTemplate = async (data) => {
  const response = await api.post(`templates`, data);
  return response.data;
};

const getEmailConfig = async (companyID) => {
  const response = await api.get(`email-configuration/${companyID}`);
  return response.data;
};

export default {
  sendMailForCampaign,
  getTemplates,
  saveTemplate,
  getEmailConfig,
};
